import React, { Fragment } from 'react';
import { TrendingUpIcon, UsersIcon, ShieldIcon, EyeOffIcon, LightbulbIcon } from 'lucide-react';
export function StrategicInsights() {
  const insights = [{
    icon: <TrendingUpIcon className="w-6 h-6 text-light-green" data-id="element-72" />,
    text: 'Ihr EBIT-Turnaround von -€2,0M auf +€3,3M im Q3 ist die stärkste operative Verbesserung im gesamten Wettbewerbsfeld — ein klares Signal an den Markt.'
  }, {
    icon: <UsersIcon className="w-6 h-6 text-passion-red" data-id="element-73" />,
    text: 'ElringKlinger verlor ~850 Mitarbeiter in einem Jahr (9.589 → 8.736) — deren SHAPE30-Restrukturierung schafft potenzielle Chancen für Polytec bei Kunden und Talenten.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-azure" data-id="element-74" />,
    text: 'ElringKlinger meldete 8 Patente im Bereich elektrochemischer Geräte — sie bauen einen IP-Schutzwall um Batterietechnologie, der Polytecs Diversifikationsstrategie bestätigt.'
  }, {
    icon: <EyeOffIcon className="w-6 h-6 text-tech-grey-50" data-id="element-75" />,
    text: 'Röchling und Woco meldeten null bei M&A, Produktentwicklung, Patenten und Partnerschaften — ein strategisches Vakuum, das Polytec nutzen kann.'
  }];
  return <section className="mb-16" data-id="element-76">
      <div className="flex items-center gap-3 mb-6" data-id="element-77">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-78">
          <LightbulbIcon className="w-5 h-5" data-id="element-79" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-tech-grey" data-id="element-80">
          Was das für Polytec bedeutet
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-81">
        {insights.map((insight, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-tech-grey-25/50 border-l-4 border-l-passion-red p-6 flex gap-4 items-start hover:shadow-md transition-shadow duration-200" data-id="element-82">
            <div className="bg-passion-red-10 p-3 rounded-full shrink-0" data-id="element-83">
              {insight.icon}
            </div>
            <p className="font-body text-tech-grey-75 font-medium leading-relaxed pt-1" data-id="element-84">
              {insight.text.split('—').map((part, i, arr) => <Fragment key={i} data-id="element-85">
                  {i === 0 ? <strong className="text-tech-grey" data-id="element-86">{part}</strong> : part}
                  {i < arr.length - 1 && ' — '}
                </Fragment>)}
            </p>
          </div>)}
      </div>
    </section>;
}